import { Component } from "react";
import { connect } from "react-redux";
import MyAbsencesTable from "../../components/Absences/MyAbsencesTable";
import AbsencesToValidateTable from "../../components/Absences/AbsencesToValidateTable";
import { getAbsences } from "../../redux/absences/absencesActions";

class AbsenceContent extends Component {
    constructor(props) {
        super(props);
        this.props.getAbsences(props.absencesToValidateMode, props.activeUser);
    }

    render() {
        if (this.props.absencesToValidateMode) {
            return (
                <div className="col-lg-12">
                    <AbsencesToValidateTable />
                </div>
            );
        } else {
            return (
                <div className="col-lg-12">
                    <MyAbsencesTable />
                </div>
            );
        }
    }
}
const mapStateToProps = (state) => {
    return {
        absencesToValidateMode: state.absences.absencesToValidateMode,
        activeUser: state.activeUser,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getAbsences: (absencesToValideMode, activeUser) => dispatch(getAbsences(absencesToValideMode, activeUser)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AbsenceContent);
